import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '../../../visual-components/link/link';

const GdprConsent: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Trans i18nKey="form.gdpr">
      <Link rel="noopener noreferrer" target="_blank" to={t('global.dataProtection.linkTo')} />
    </Trans>
  );
};

export default GdprConsent;
